import React from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";
import HighchartsMore from 'highcharts/highcharts-more';

HighchartsMore(Highcharts)
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)
Theme(Highcharts)

const BubbleChart: any =(props:any)=>{

    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
    const {allData, exportExcel, labels, title, idChart, activeButton, yTitle='Aprobación/Imagen Positiva'} = props;
    const options = {

        chart: {
            type: 'bubble',
            backgroundColor: '#ffffff',
            
            plotBorderWidth: 1,
            zoomType: 'xy'
        },
    
        title: {
            text: title,
            style: {
				color: '#19355F',
				fontFamily: 'Montserrat-SemiBold'
            }
        },
        subtitle: {
            text: ''
        },
        
        responsive: {  
			rules: [{  
			  condition: {  
				maxWidth: 1000
			  },  
			  chartOptions: {
                legend: {
                    padding:20,
                    enabled: true,
                    symbolPadding: 5,
                    itemDistance:60,
                    backgroundColor: '#FFFFFF',
                    itemStyle: {
                        color: '#19355F',
                        fontFamily: 'Montserrat',
                        fontSize: '10px',
                        fontWeight: 'normal',
                        padding: 50
                    }
                },
            
               
                subtitle: {
                    text: null
                },
            
                
            }
			}]  
		},

        xAxis: {
            gridLineWidth: 0,
            startOnTick: false,
            endOnTick: false,
            title:{
                text:'CONOCIMIENTO'
            },
            plotLines: [{
                color: 'black',
                dashStyle: 'dot',
                width: 2,
                value: 50,
                label: {
                    rotation: 0,
                    y: 15,
                    style: {
                        fontStyle: 'italic'
                    },
                },
                zIndex: 3
            }]
        },
    
        yAxis: {
            minorGridLineWidth: 0,
			gridLineWidth: 0,
            startOnTick: false,
            endOnTick: false,
            title:{
                text:yTitle,
                style: {
					fontFamily: 'Montserrat, sans-serif',
					color: '#19355F'
				  }
            },
            plotLines: [{
                color: 'black',
                dashStyle: 'dot',
                width: 2,
                value: 50,
                visible: true,
                label: {
                    align: 'right',
                    style: {
                        fontStyle: 'italic'
                    },
                    text: '',
                    x: -10
                },
                zIndex: 3
            }],
            
        },
        legend: {
            padding:20,
            enabled: true,
            symbolPadding: 5,
            itemDistance:60,
            backgroundColor: '#FFFFFF',
            itemStyle: {
                color: '#19355F',
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: 'normal',
                padding: 50
            }
        },
        //
        series: allData,

        tooltip: {
			shared: true,
			useHTML: true,
			headerFormat: '<table><tr style="color: {series.color}"><th colspan="2">{series.name}</th></tr>',
			pointFormat: '<tr><td><b>Conocimiento:</b> </td>' +
				        '<td style="text-align: right"><b>{point.x}%</b></td></tr>' +
                        '<tr><td><b>Imagen Positiva:</b> </td>' +
				        '<td style="text-align: right"><b>{point.y}%</b></td></tr>',
			footerFormat: '</table>',
			valueDecimals: 0
		},

        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    format: '{point.name}'
                }
            }
        },
        lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",      
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
		},
        exporting: {
			enabled: activeButton, 
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportExcel({titulo: title, id: idChart});
					},
					text: 'Descargar XLSX'
				}
			},
			
			buttons: {
				contextButton: {
					menuItems: [
						"viewFullscreen",
						"printChart",
						"separator",
						"downloadPNG",
						"downloadJPEG",
						"downloadPDF",
						"downloadSVG",
						"separator",
						"label"
					]
				}
			}
		},
        credits: {
            enabled: true,
            text: 'El dato de Figuras Políticas corresponde a Febrero de 2024 y el dato de Ministros a Enero de 2024.',
            style: {
              fontSize: '10px',
              fontFamily: 'Montserrat',
              color: '#19355F',
              
            },
            useHTML: true ,// Permite el uso de HTML en el pie de página
            position: {
              align: 'right',
              x: -10,
              verticalAlign: 'bottom',
              y: -5
            }
          },

        
    
    };
    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}

export default BubbleChart;